import StepDrawer from "./StepDrawer";
import RatingCheckbox from "./RatingCheckbox";
import { useState } from 'react';

function SatisfactionSelection({
    onContinue,
    currentStep,
    totalSteps,
    onBack,
    onCancel,
    formData,
    setFormData
}) {
    const handleChange = (score) => {
        if (formData.rating === score) {
            setFormData({
                ...formData,
                rating: null
            })
        } else {
            setFormData({
                ...formData,
                rating: score
            })
        }
    }
    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            onCancel={onCancel}
            onContinue={onContinue}
            title={
                <span>Overall Satisfaction <span style={{ color: '#9BA3AF' }}>(Optional)</span></span>
            }
            onBack={onBack}
            showSkip={!formData.rating}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p className="selection-hint" style={{ textAlign: 'center', padding: '1rem 0' }}>
                    Overall, how satisfied are you with your surgery and recovery up to this point?
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {[5, 4, 3, 2, 1].map(satisfaction => {
                        return <div key={satisfaction} style={{ padding: '0.5rem 0' }}>
                            <RatingCheckbox
                                id={satisfaction}
                                checked={satisfaction === formData.rating}
                                onChange={() => handleChange(satisfaction)}
                            />
                        </div>
                    })}
                </div>
                {!formData.rating && (
                    <>
                        <p className="selection-hint" style={{ color: 'rgb(156, 163, 175)', paddingTop: '1rem' }} >Prefer not to say?</p>
                        <div onClick={onContinue} style={{ color: '#3498db', cursor: 'pointer' }}>Skip this step</div>
                    </>
                )}
            </div>
        </StepDrawer>
    )
}

export default SatisfactionSelection;